import { FunctionComponent, useState } from 'react';
import { SectionTitle } from '../shared-components/SectionTitle';
import FFFBox from '../../MyAccount/Orders/ProductsList/Box/fff-box.png';
import * as styles from './OrderDetails.module.scss';

export type ProductType = {
  name: string;
  imageUrl: string;
};

export type OrderDetailsType = {
  productType: string;
  seasonCode: string;
  items: Array<ProductType>;
};

export type OrderDetailsProps = {
  orderDetails: Array<OrderDetailsType>;
};

const PRODUCT_TYPE_ORDER = [
  'box',
  'addons',
  'replenishment',
  'additionalChoices',
  'edit',
  'boost',
  'shop',
  'subscriptions',
];

const getTitle = (sortedProductTypes: Array<string>) => {
  return sortedProductTypes.join(', ').replace('addons', 'Add-Ons');
};

const getSortedProductTypes = (sortedOrders: Array<OrderDetailsType>): string[] => {
  return sortedOrders.reduce((uniqueTypes, order) => {
    if (!uniqueTypes.includes(order.productType)) {
      uniqueTypes.push(order.productType);
    }
    return uniqueTypes;
  }, [] as string[]);
};

export const OrderDetails: FunctionComponent<OrderDetailsProps> = ({ orderDetails }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const handleToggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const sortedOrders = [...orderDetails].sort(
    (a, b) => PRODUCT_TYPE_ORDER.indexOf(a.productType) - PRODUCT_TYPE_ORDER.indexOf(b.productType),
  );

  const sortedProductTypes = getSortedProductTypes(sortedOrders);

  const sortedProducts = sortedOrders.flatMap((order) =>
    order.productType === 'box' ? [] : order.items,
  );

  const hasBox = orderDetails.some((order) => order.productType === 'box');

  const productsToDisplay = sortedProducts.filter((product: ProductType) => product.imageUrl);

  return (
    <div className={styles.container}>
      <SectionTitle
        title="Your Order"
        isDrawerOpen={isDrawerOpen}
        handleToggleDrawer={handleToggleDrawer}
      />
      {isDrawerOpen && (
        <div>
          <h2 className={styles.orderName}>{getTitle(sortedProductTypes)}</h2>

          <div className={styles.productsContainer}>
            {hasBox && (
              <div className={styles.product}>
                <img src={FFFBox} alt="Box" data-testid="static-box-image" />
              </div>
            )}
            {productsToDisplay.map((product: ProductType, index: number) => (
              <div className={styles.product} key={`product-${index}`}>
                <img src={product.imageUrl} alt={product.name} data-testid="product-image" />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
